/**
 * Custom API Error class for better error handling
 */
export class ApiError extends Error {
  constructor(message, status, statusText, response) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.statusText = statusText;
    this.response = response;
    this.timestamp = new Date().toISOString();
  }

  /**
   * Check if error is due to authentication issues
   */
  isAuthError() {
    return this.status === 401 || this.status === 403;
  }

  /**
   * Check if error is due to network issues
   */
  isNetworkError() {
    return this.status === 0 || this.status >= 500;
  }

  /**
   * Check if error is due to client-side issues
   */
  isClientError() {
    return this.status >= 400 && this.status < 500;
  }

  /**
   * Get user-friendly error message
   */
  getUserMessage() {
    if (this.isAuthError()) {
      return 'Session expirée ou opération non authorisée.';
    }
    if (this.isNetworkError()) {
      return 'Erreur de connexion. Vérifiez votre réseau.';
    }
    if (this.status === 404) {
      return 'Ressource non trouvée.';
    }
    if (this.status === 409) {
      return 'Conflit de données. Veuillez réessayer.';
    }
    return this.message || 'Une erreur inattendue s\'est produite.';
  }
}

/**
 * Network Error for connection issues
 */
export class NetworkError extends Error {
  constructor(message = 'Erreur de réseau') {
    super(message);
    this.name = 'NetworkError';
    this.timestamp = new Date().toISOString();
  }
}

/**
 * Validation Error for data validation issues
 */
export class ValidationError extends Error {
  constructor(message, field = null) {
    super(message);
    this.name = 'ValidationError';
    this.field = field;
    this.timestamp = new Date().toISOString();
  }
}

/**
 * Timeout Error for request timeouts
 */
export class TimeoutError extends Error {
  constructor(message = 'Délai d\'attente dépassé') {
    super(message);
    this.name = 'TimeoutError';
    this.timestamp = new Date().toISOString();
  }
}
